import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

/**
 * @typedef {Object} SelfServiceStatsDataReducer
 * @property {string} dealerName
 * @property {number} proposed
 * @property {string} dealerId
 * @property {number} checkInSent
 * @property {number} checkOutSent
 * @property {number} accepted
 * @property {number} kioskCheckInCompleted
 * @property {number} homeCheckInCompleted
 * @property {number} id
 * @property {number} kioskCheckOutCompleted
 * @property {number} acceptedExtraOrProactive
 * @property {number} proposedExtraOrProactive
 */

/** @type {SelfServiceStatsDataReducer[]} */
const initialState = [];

/**
 * @param {SelfServiceStatsDataReducer[]} _
 * @param {import('modules/statistics/types').FetchSelfServiceStatisticsSuccessAction} action
 * @returns {SelfServiceStatsDataReducer[]}
 */
const updateAllData = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_DASHBOARD_SELF_SERVICE_STATS_SUCCESS]: updateAllData,
});
